module.exports = __webpack_public_path__ + "media/desescalada.2a538db3.mp4";